/**
 * task completion items related methods are kept here
 */

import axios, { baseRequestConfig } from './base';


export function getTaskCompletionQuestionTypes(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_types',
      },
    },
  });
}

export function listTaskCompletionItem(userToken, taskId) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_items_list',
        values: {
          task_id: taskId,
        },
      },
    },
  });
}

export function addTaskCompletionItem(userToken, taskCompletionItem) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_item_add',
        values: {
          ...taskCompletionItem,
        },
      },
    },
  });
}

export function updateTaskCompletionItem(userToken, taskCompletionItem) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_item_update',
        values: {
          ...taskCompletionItem,
        },
      },
    },
  });
}

export function removeTaskCompletionItem(userToken, taskCompletionItem) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_item_rem',
        values: {
          ...taskCompletionItem,
        },
      },
    },
  });
}

export function resortTaskCompletionItem(userToken, taskId, taskRankRange, taskCompletionList) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'task_completion_items_resort',
        values: {
          task_id: taskId,
          task_completion_rank_range: taskRankRange,
          task_completion_list: taskCompletionList,
        },
      },
    },
  });
}

export function getOrganizerTaskCompletions(userToken, values) {
  return axios
    .request({
      method: 'post',
      data: {
        ...baseRequestConfig(),
        user_token: userToken,
        request1: {
          request_type: 'FUNCTION',
          function_name: 'user_organizer_taskcompletions',
          values,
        },
      },
    });
}

export function getTaskCompletionDetails(userToken, completionId) {
  return axios
    .request({
      method: 'post',
      data: {
        ...baseRequestConfig(),
        user_token: userToken,
        request1: {
          request_type: 'FUNCTION',
          function_name: 'complete_get_data',
          values: {
            completion_id: completionId,
          },
        },
      },
    });
}

export function submitCompletionReview(userToken, payload) {
  return axios
    .request({
      method: 'post',
      data: {
        ...baseRequestConfig(),
        user_token: userToken,
        request1: {
          request_type: 'FUNCTION',
          function_name: 'user_organizer_review_completion',
          values: payload,
        },
      },
    });
}



// WEBPACK FOOTER //
// ./src/api/task_completion.js